import { DiscordSupportLink } from './RewardsErrorStates';

interface RedeemFailureProps {
  error: string | null;
  onRetry: () => void;
  onBack: () => void;
}

export function RedeemFailure({ error, onRetry, onBack }: RedeemFailureProps) {
  const refundMessage = error?.includes('FULFILLMENT_FAILED') ? '\nYour tokens have been refunded.' : '';

  return (
    <>
      <div className='flex min-h-0 flex-1 flex-col items-center justify-center' style={{ opacity: 0.35 }}>
        {/* Dimmed background content placeholder */}
      </div>
      <div className='absolute inset-0 z-40 rounded-[12px] bg-[#0b0618] opacity-[0.72]' />
      <div className='absolute inset-0 z-50 flex items-center justify-center p-4'>
        <div className='w-full rounded-[10px] border border-[#FFFFFF]/15 bg-[#0b0618] p-4'>
          <p className='mb-2 text-center text-base font-semibold text-white'>Redemption Failed</p>
          <p className='mb-[14px] whitespace-pre-line text-center text-sm text-[#FFFFFF]/80' style={{ lineHeight: 1.45 }}>
            {error ?? 'Something went wrong.'}{refundMessage}
          </p>
          <div className='flex flex-col gap-2'>
            <button type='button' onClick={onRetry}
              style={{ minHeight: 44, borderRadius: 8, fontSize: 15 }}
              className='flex w-full items-center justify-center border-none bg-[#FBBF24] font-semibold text-[#020617] transition-transform hover:scale-[1.02] active:scale-[0.98]'>
              Try Again
            </button>
            <button type='button' onClick={onBack}
              style={{ minHeight: 44, borderRadius: 8 }}
              className='flex w-full items-center justify-center border-none bg-transparent text-sm font-medium text-[#FFFFFF]/80 transition-opacity hover:opacity-80'>
              Dismiss
            </button>
          </div>
          <div className='mt-3 text-center'>
            <DiscordSupportLink />
          </div>
        </div>
      </div>
    </>
  );
}

interface RedeemOutOfStockProps {
  restockLabel: string;
  restockDate: string;
  onBack: () => void;
}

export function RedeemOutOfStock({ restockLabel, restockDate, onBack }: RedeemOutOfStockProps) {
  return (
    <>
      <div className='flex min-h-0 flex-1 flex-col' style={{ opacity: 0.35 }}>
        {/* Dimmed background content placeholder */}
      </div>
      <div className='absolute inset-0 z-40 rounded-[12px] bg-[#0b0618] opacity-[0.72]' />
      <div className='absolute inset-0 z-50 flex items-center justify-center p-4'>
        <div className='w-full rounded-[10px] border border-[#FFFFFF]/15 bg-[#0b0618] p-4'>
          <p className='text-center text-[16px] font-semibold text-white' style={{ marginBottom: 8 }}>Out of stock</p>
          <p className='text-center text-[13px] text-[#FFFFFF]/80' style={{ lineHeight: 1.45, marginBottom: 10 }}>
            This reward just sold out before your redeem went through. Your tokens were not spent.
          </p>
          {restockLabel && (
            <p className='text-center text-[13px] text-[#FFFFFF]/80' style={{ marginBottom: 6 }}>
              Restock in{' '}
              <span className='font-semibold' style={{ fontFamily: 'monospace' }}>{restockLabel}</span>
            </p>
          )}
          {restockDate && (
            <p className='text-center text-[10px] text-[#FFFFFF]/70' style={{ marginBottom: 14 }}>
              {restockDate}
            </p>
          )}
          <button type='button' onClick={onBack}
            style={{ minHeight: 44, borderRadius: 8, fontSize: 15 }}
            className='flex w-full items-center justify-center border-none bg-[#FBBF24] font-semibold text-[#020617] transition-transform hover:scale-[1.02] active:scale-[0.98]'>
            Got it
          </button>
        </div>
      </div>
    </>
  );
}
